import { typed } from 'mathjs';

export const ifFunction = typed('if', {
  'boolean | number, number | string, number | string': function (
    a: boolean | number,
    b: number | string,
    c: number | string
  ) {
    return a ? b : c;
  }
});
